import { Flex, Header, IconMenuButton } from '@driftt/dds'
import React from 'react'

import { StyledContainer, StyledContent } from './styles'

interface Props {
  children: React.ReactNode
  isEditing: boolean
  onEdit: () => void
  onCancel: () => void
  disabled: boolean
  isCard: boolean
}

const AttributesSection = ({
  isEditing,
  onEdit,
  onCancel,
  children,
  disabled,
  isCard,
}: Props) => {
  const menuOptions = isEditing
    ? [{ name: 'Cancel', action: onCancel }]
    : [{ name: 'Edit', action: onEdit }]

  if (!isCard) return <>{children}</>

  return (
    <StyledContainer direction="column" fullWidth>
      <Flex justifyContent="space-between" fullWidth>
        <Header variant="h3">Found attributes</Header>
        <IconMenuButton
          iconVariant="spillover"
          options={menuOptions}
          title="Actions"
          disabled={disabled}
        />
      </Flex>
      <StyledContent>{children}</StyledContent>
    </StyledContainer>
  )
}

export default AttributesSection
